<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" class="form-control" @change="cambiarDatos($event)" :disabled="deshabilitado">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un estatus de la audiencia</option>
        <option v-else="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los estatus de las audiencias</option>
        <option v-for="TipoEstatusDeLaAudiencia in TiposEstatusDeLaAudiencia" :value="TipoEstatusDeLaAudiencia.TipoEstatusDeAudienciaId">{{TipoEstatusDeLaAudiencia.Nombre}}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import axios from 'axios';
  import api from '@/../static/js/api';
  import comun from '@/../static/js/comun';

  export default {
    data() {
      return {
        enumeraciones,
        comun,
        TiposEstatusDeLaAudiencia: [],
        idDelModelo: null
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String 
      },
      idDelInput: String,
      valorDefinido: Number,
      parametros: Object,
      deshabilitado: false
    },
    mounted() {      
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }
      
      this.$store.dispatch("A_Forseti_Catalogo_Establecer001TipoEstatusDeAudiencia", parametros);
    },
    methods: {
      cargaCatalogoTiposEstatusDeLaAudiencia() {        
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {}
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba      
                
        axios.post(api.conexion + api.Forseti.catalogos.C001TiposEstatusDeLaAudiencia, this.parametros)
          .then(respuesta => {            
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {              
              this.TiposEstatusDeLaAudiencia = respuesta.data.TiposEstatusDeAudiencia;

              if (this.parametros.filtros != undefined && this.parametros.filtros != null) {
                this.TiposEstatusDeLaAudiencia = respuesta.data.TiposEstatusDeAudiencia.filter(cond => this.parametros.filtros.some(tipo => tipo == cond.TipoEstatusDeAudienciaId));
              }
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          })
      },
      cambiarDatos(evento) {
        this.idDelModelo = evento.target.value;
        const parametros = {
          llave: this.idDelInput,
          valor: evento.target.value
        }
        
        this.$store.dispatch("A_Forseti_Catalogo_Establecer001TipoEstatusDeAudiencia", parametros);
        this.$emit("valorParaElPadre", evento);
        //evento.target[evento.target.selectedIndex].label esto sirve para obtener el label de valor actual
      }
    },
    created() {
      this.cargaCatalogoTiposEstatusDeLaAudiencia();
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Forseti/Comun/Catalogos/001TiposEstatusDeLaAudiencia.vue